<template>
    <div>
        <div class="page">
            <div class="container px-11 2xl:px-3 my-14 m-auto">
                <title-s-chapter
                    :options="{
                        from: 'from-selective_orange',
                        to: 'to-selective_yellow',
                    }"
                >
                    <h1 v-html="currentPage.content.pageTitle.text"></h1>
                </title-s-chapter>
                <p
                    class="font-bold text-tundora text-xl mb-5"
                    v-html="currentPage.content.pageDescription.text"
                ></p>
                <div class="container-components mb-4 lg:mb-8">
                    <div>
                        <image-with-descriptions
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image1.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image1.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_orange',
                                to: 'to-selective_yellow',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#F27E27', '#F15921', '#f15923'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.firstParagraphSubTitle
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.firstParagraphText.text
                                "
                            >
                            </span>
                        </paragraph>
                    </div>
                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_orange',
                                to: 'to-selective_yellow',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.secondParagraphSubTitle
                                        .text
                                "
                            ></span>
                            <Triangles
                                :options="{
                                    colors: ['#F27E27', '#F15921', '#f15923'],
                                    direction: 'bottom',
                                }"
                            />
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.secondParagraphText.text
                                "
                            >
                            </span>
                        </paragraph>
                        <image-with-descriptions
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image2.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image2.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>
                    <div class="card">
                        <div class="break-inside-avoid">
                            <div class="pt-10 xl:pt-14">
                                <hotspot-richmedia
                                    :options="{
                                        icon: 'diaporama',
                                        collection: getRichmediaByCollection(
                                            currentPage,
                                            'ENR, Le Maroc fait appel au CIH - Hydréole n°58'
                                        ),
                                    }"
                                    class="-top-2 xl:top-2 -right-2"
                                />
                            </div>

                            <TitleParagraph
                                :options="{
                                    from: 'from-selective_orange',
                                    to: 'to-selective_yellow',
                                }"
                            >
                                <span
                                    v-html="
                                        currentPage.content
                                            .thirdParagraphSubTitle.text
                                    "
                                ></span>
                                <Triangles
                                :options="{
                                    colors: ['#F27E27', '#F15921', '#f15923'],
                                    direction: 'right',
                                }"
                            />
                            </TitleParagraph>
                        </div>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.thirdParagraphText.text
                                "
                            >
                            </span>
                            <span class="block md:hidden"></span>
                            
                        </paragraph>
                        <image-with-descriptions
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image3.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image3.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>
                    <div class="flex flex-col mb-4">
                        <div>
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.image4.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image4.edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>

                        <div class="grid grid-cols-2">
                            <image-with-descriptions
                                style="margin: 0"
                                class="object-cover"
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.image6.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image6.edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                            <image-with-descriptions
                                style="margin: 0"
                                class="object-cover"
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.image5.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image5.edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>

                    <div class="card">
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_orange',
                                to: 'to-selective_yellow',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#F27E27', '#F15921', '#f15923'],
                                    direction: 'left',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.fourthParagraphSubTitle
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.fourthParagraphText.text
                                "
                            >
                            </span>
                            <!-- <Dots
                                :options="{
                                    colors: ['#F27E27', '#F15921', '#f15923'],
                                }"
                            /> -->
                        </paragraph>
                    </div>
                </div>
                <div class="card my-10">
                    <paragraph
                        style="margin-bottom: 0"
                        :options="{
                            color: 'text-nandor',
                        }"
                    >
                        <Dots
                            :options="{
                                colors: ['#F27E27', '#F15921', '#f15923'],
                            }"
                        />
                        <span
                            class="font-bold text-tundora"
                            v-html="currentPage.content.fifthParagraphText.text"
                        >
                        </span>
                    </paragraph>
                </div>
                <div class="container-components mb-4 lg:mb-8">
                    <div class="card">
                        <div class="relative">
                                
                                <hotspot-richmedia
                                    :options="{
                                        icon: 'diaporama',
                                        collection: getRichmediaByCollection(
                                            currentPage,
                                            'Le bureau d’études à Savoie Technolac'
                                        ),
                                    }"
                                    class="top-2 right-2"
                                />
                            
                            <image-with-descriptions
                                class="eliminate-margin"
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.image7.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image7.edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_orange',
                                to: 'to-selective_yellow',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#F27E27', '#F15921', '#f15923'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.fifthParagraphSubTitle
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.sixthParagraphText.text
                                "
                            >
                            </span>
                        </paragraph>
                    </div>
                    <div class="card break-inside-avoid">
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_orange',
                                to: 'to-selective_yellow',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#F27E27', '#F15921', '#f15923'],
                                    direction: 'bottom',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.sixthParagraphSubTitle
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.eigthParagraphText.text
                                "
                            >
                            </span>
                            <!-- <Dots
                                :options="{
                                    colors: ['#F27E27', '#F15921', '#f15923'],
                                }"
                            /> -->
                        </paragraph>
                    

                        <image-with-descriptions
                            class="object-cover"
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image8.src,
                                descriptions: [],
                            }"
                        />
                        <div
                            class="
                                absolute
                                inline-block
                                w-auto
                                bottom-2
                                lg:bottom-10
                                -right-10
                                lg:lg:-right-14 xl:font-bold
                                transform
                                text-white text-right text-xs
                                xl:text-base
                                origin-bottom-right
                                xl:origin-top-right
                                -translate-x-full
                            "
                        >
                            <span
                                v-html="currentPage.images.image8.text"
                            ></span>
                        </div>
                        
                    </div>
                    <div class="card break-inside-avoid">
                        <article-note class="overflow-hidden"
                            :options="{
                                verticalcontent:
                                    currentPage.content.verticalText.text,

                                color: {
                                    verticalcontent: 'text-cornflower_blue',
                                    content: 'text-selective_yellow',
                                },
                                fontSize: {
                                    verticalcontent: 'text-2xl xl:text-3xl',
                                },
                                margin: {},
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image9.src,
                            }"
                        />
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_orange',
                                to: 'to-selective_yellow',
                            }"
                        >
                        <Triangles
                                :options="{
                                    colors: ['#F27E27', '#F15921', '#f15923'],
                                    direction: 'top',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.seventhParagraphSubTitle
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <span
                            class="text-nandor"
                            v-html="currentPage.content.ninthParagraphText.text"
                        >
                        </span>

                        <paragraph
                            style="margin: 0"
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                class="
                                    m-0
                                    text-cornflower_blue
                                    text-5xl
                                    lg:text-7xl
                                    2xl:text-8xl
                                "
                                v-html="
                                    currentPage.content.tenthParagraphText.text
                                "
                            >
                            </span>
                            <span
                                v-html="
                                    currentPage.content.twelfthParagraphText
                                        .text
                                "
                            >
                            </span>
                        </paragraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.eleventhParagraphText
                                        .text
                                "
                            >
                            </span>
                        </paragraph>
                    </div>
                    </div>

                    
                <div class="container-components md:my-7 p-2.5" style="background-color: #f2f2f2;">
                    

                    <div class="card " >
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_orange',
                                to: 'to-selective_yellow',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#F27E27', '#F15921', '#f15923'],
                                    direction: 'right',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.eigthParagraphSubTitle
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.thirteenParagraphText
                                        .text
                                "
                            >
                            </span>
                        </paragraph>
                        <div>
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.image10.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image10
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </div>

                    <div class="mx-auto w-full">
                        <image-with-descriptions
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image11.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image11.alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                ],
                            }"
                        />
                    </div>
                </div>
                <div class="container-components">
                    <div class="card" style="padding: 0;">
                        <TitleParagraph
                            :options="{
                                from: 'from-selective_orange',
                                to: 'to-selective_yellow',
                            }"
                        >
                            <Triangles
                                :options="{
                                    colors: ['#F27E27', '#F15921', '#f15923'],
                                    direction: 'bottom',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.nineParagraphSubTitle
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <div class="relative">
                            <image-with-descriptions
                                :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.image12.src,
                                    descriptions: [],
                                }"
                            />
                        </div>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.fourteenParagraphText
                                        .text
                                "
                            >
                            </span>
                        </paragraph>
                        
                    </div>

                    <div class="card break-inside-avoid" style="padding: 0;">
                        <div class="">
                            <hotspot-richmedia
                                :options="{
                                    icon: 'diaporama',
                                    collection: getRichmediaByCollection(
                                        currentPage,
                                        'Screening, la quête du spot idéal'
                                    ),
                                }"
                                class="top-0 -right-6 2xl:-right-2"
                            />
                        </div>

                        <TitleParagraph
                            :options="{
                                from: 'from-selective_orange',
                                to: 'to-selective_yellow',
                            }"
                        >
                            <Triangles style="margin:0; margin-right:0.25rem;"
                                :options="{
                                    colors: ['#F27E27', '#F15921', '#f15923'],
                                    direction: 'bottom',
                                }"
                            />
                            <span
                                v-html="
                                    currentPage.content.ninthParagraphSubTitle
                                        .text
                                "
                            ></span>
                        </TitleParagraph>
                        <paragraph
                            :options="{
                                color: 'text-nandor',
                            }"
                        >
                            <span
                                v-html="
                                    currentPage.content.fiftheenParagraphText
                                        .text
                                "
                            >
                            </span>
                            <!-- <square
                                :options="{
                                    from: 'from-selective_orange',
                                    to: 'to-selective_yellow',
                                }"
                            /> -->
                        </paragraph>
                        <image-with-descriptions
                            :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image13.src,
                                descriptions: [],
                            }"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import TitleSChapter from "../../components/TitleSChapter.vue";
import Triangles from "../../components/Triangles.vue";
import TitleParagraph from "../../components/TitleParagraph.vue";
import Paragraph from "../../components/Paragraph.vue";
import ImageWithDescriptions from "../../components/ImageWithDescriptions.vue";

export default {
    components: {
        TitleSChapter,
        Triangles,
        TitleParagraph,
        ImageWithDescriptions,
        Paragraph,
    },
    name: "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang="scss"></style>
